import AreaTipoDivergenciaEnum from "../../AreaTipoDivergenciaEnum";
import { useBuildFinalStepTemplate } from "../../template/FinalStepTemplate";
import useBuildSubmitHandler from "../../template/UseBuildSubmitHandler";
import TipoDivergenciasKey from "../../TipoDivergenciasKey";
import { TipoDivergenciaComponent } from "../../TiposDeDivergencias";

const FaltaDeMolde: TipoDivergenciaComponent = ({ onBack, onSetStep }) => {
  const key = TipoDivergenciasKey.FALTA_DE_MOLDE;
  const { loadingSave, loadingTipoDivergencia, handleSubmit } =
    useBuildSubmitHandler(key, onSetStep);

  return useBuildFinalStepTemplate({
    area: AreaTipoDivergenciaEnum.MODELAGEM,
    loading: loadingSave || loadingTipoDivergencia,
    onBack,
    onSetStep: handleSubmit,
    tipoDivergencia: "Falta de molde",
  });
};

export default FaltaDeMolde;
